'use client';

import { getClassNames, isBrowser } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmPin } from '@websolutespa/bom-mixer-icons';
import { LlmBlock, LlmChunkEvent, LlmChunkEventItem } from '../../../types';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import { Cta } from '../../components/Cta/cta';

export const Event: React.FC<LlmBlock<LlmChunkEventItem | LlmChunkEvent>> = (props) => {
  const { item } = props;
  const label = useLabel();
  const { decorateUrl } = useLlm(state => state.actions);
  const { send } = useLlmView(state => state.actions);
  const onTellMeMore = async (event: React.MouseEvent) => {
    const prompt = `${label('llm.tellMeMoreAbout')} ${item.title}`;
    await send(prompt, (response) => {
      // console.log('Prompt.onChunk', response.chunks);
    }, (response) => {
      // console.log('Prompt.onEnd', response);
    });
  };
  const onGoToWebsite = async (event: React.MouseEvent) => {
    if (isBrowser) {
      event.preventDefault();
      const url = await decorateUrl(item, item.url);
      window.open(url, '_blank');
    }
  };
  const classNames = getClassNames('llm__event', { [`llm__event--${item.type}`]: !!item.type });
  return (
    <div className={classNames}>
      <div className="llm__event-inner">
        <div className="llm__event-content">
          {item.type == 'event' && <div className="llm__event-pretitle">
            {label('llm.eventPretitle')}
          </div>}
          {item.title && (
            <div className="llm__event-title" dangerouslySetInnerHTML={{ __html: item.title }} />
          )}
          {item.abstract && (
            <div className="llm__event-body" dangerouslySetInnerHTML={{ __html: item.abstract }} />
          )}
          {item.place && (
            <div className="llm__event-location">
              <IconLlmPin /> {item.place}
            </div>
          )}
          <div className="llm__event-ctas">
            <Cta type="button" label={label('llm.tellMeMore')} onClick={onTellMeMore} />
            <Cta type="text" label={label('llm.goToWebsite')} onClick={onGoToWebsite} />
          </div>
        </div>
        {item.image && (
          <div className="llm__event-media">
            <div className="llm__event-asset">
              <img src={item.image} alt="" />
            </div>
            {(item.time || item.date) && (
              <div className="llm__event-tags">
                {item.date && (
                  <div className="llm__event-tag llm__event-date">{item.date}</div>
                )}
                {item.time && (
                  <div className="llm__event-tag llm__event-time">{item.time}</div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

